'use client';

// Listens for "jigyasa:launch-flow-guide" (fired by the onboarding checklist's
// No. 1 step) and starts the Ashraya guided walkthrough of the enquiry-flow
// setup — the right variant for Solo vs Team.

import { useEffect } from "react";
import { useTourEngine, sendAshraryaMessage } from "../packages/aumonline-ashraya/src";

export function AshrayaGuideLauncher({ config, isSolo = false }) {
  const { startTour } = useTourEngine();

  useEffect(() => {
    const onLaunch = async () => {
      try {
        const res = await sendAshraryaMessage({
          webhookUrl: config.webhookUrl,
          headers: config.requestHeaders,
          payload: {
            app_namespace: config.appNamespace,
            intent: "flow_guide",
            variant: isSolo ? "solo" : "full",
            user: config.user,
            session_id: null,
            channel: "text",
            input: { type: "text", content: "Set up my enquiry flow", language: "en", intent: "flow_guide" },
            client_meta: {
              variant: isSolo ? "solo" : "full",
              current_path: typeof window !== "undefined" ? window.location.pathname : "/",
            },
          },
        });
        const tour = res?.tour;
        if (tour && Array.isArray(tour.steps) && tour.steps.length > 0) {
          startTour(tour);
        }
      } catch (err) {
        if (config.debug) {
          // eslint-disable-next-line no-console
          console.warn("[Ashraya] flow guide launch failed:", err);
        }
      }
    };
    window.addEventListener("jigyasa:launch-flow-guide", onLaunch);
    return () => window.removeEventListener("jigyasa:launch-flow-guide", onLaunch);
  }, [config, isSolo, startTour]);

  return null;
}
